module.exports = __webpack_public_path__ + "img/1f3ce.5410f22.svg";